<script>
import AddressForm from '@/components/address-form/address-form'
import countries from '@/data/countries'
import { mapGetters } from 'vuex'
import sharedService from '@/utils/shared-service'
import { BILLING_ADDRESS_PREFERENCES } from '@/utils/constant'

export default {

  name: 'BillingAddress',
  inject: ['$validator'],
  components: {
    AddressForm
  },

  data () {
    return {
      BILLING_ADDRESS_PREFERENCES: BILLING_ADDRESS_PREFERENCES,
      billingCountries: countries,
      billingAddressSuccess: false,
      labels: {
        name: this.$t('addressForm.name'),
        complemento: this.$t('addressForm.complemento'),
        neighborhood: this.$t('addressForm.neighborhood'),
        countryCode: this.$t('addressForm.countryCode'),
        line1: this.$t('addressForm.line1'),
        line2: this.$t('addressForm.line2'),
        line3: this.$t('addressForm.line3'),
        city: this.$t('addressForm.cityTown'),
        subdivision: this.$t('addressForm.subdivision'),
        postalCode: this.$t('addressForm.postalCode'),
        optional: this.$t('addressForm.optional'),
        streetName: this.$t('addressForm.streetName'),
        streetNumber: this.$t('addressForm.streetNumber')
      }
    }
  },

  computed: {

    billingCountryCodes: {
      get () {
        return this.$store.state.configuration.checkout.billingCountryCodes
      },
      set (value) {
        this.$store.commit('updateBillingCountryCodes', value)
        sharedService.updateCheckoutButton(false)
      }
    },

    billingAddressPreference: {
      get () {
        return this.$store.state.configuration.checkout.billingAddress
      },
      set (value) {
        this.$store.commit('updateBillingAddress', value)
        sharedService.updateCheckoutButton(false)
        sharedService.updateConsumerBillingAddress(value)
        this.$validator.reset()
      }
    },

    ...mapGetters(['consumerBillingAddress'])
  },

  methods: {

    onBillingAddressSave (value) {
      this.billingAddressSuccess = value
      setTimeout(() => {
        this.billingAddressSuccess = false
      }, 5000)
    }
  }
}
</script>
<template>
  <div
    id="billingAddressConfiguration"
    class="card mb-4">
    <h5
      id="billingAddressHeader"
      aria-controls="collapseBillingAddress"
      aria-expanded="true"
      class="card-header collapsed cursor-pointer"
      data-target="#collapseBillingAddress"
      data-toggle="collapse"
    >
      <span class="font-weight-bold">{{ $t('header.billingAddressPreference') }}</span>
      <span class="collapsible-arrow pull-right"/>
    </h5>
    <div
      id="collapseBillingAddress"
      aria-labelledby="headingBillingAddress"
      class="card-body collapse"
    >
      <label>{{ $t('label.chooseBillingAddressPreference') }}</label>
      <div id="billingAddressPreference">
        <div
          v-for="(value, key) in BILLING_ADDRESS_PREFERENCES"
          :key="value"
          class="form-check form-check-inline"
        >
          <input
            :id="'radio-' + key"
            v-model="billingAddressPreference"
            :data-test="'radio-' + key"
            :name="'billing-'+ key"
            :value="key"
            class="form-check-input"
            type="radio"
          >
          <label class="form-check-label">{{ value }}</label>
          <div class="clear"/>
        </div>
      </div>
      <hr class="my-4">
      <div class="form-group">
        <label class="font-weight-bold">{{ $t('label.acceptedBillingCountriesCode') }}</label>
        <p>{{ $t('label.acceptedBillingCountriesCodeDescription') }}</p>
        <input
          id="input-billing-profiles"
          v-model="billingCountryCodes"
          class="form-control"
          data-test="input-billing-profiles"
          type="text"
        >
      </div>
      <hr class="my-4">
      <label class="font-weight-bold">{{ $t('addressForm.billingAddressTitle') }}</label>
      <div
        v-if="billingAddressSuccess"
        class="alert alert-success mt-3"
      >
        {{ $t('successMessages.BILLING_ADDRESS_SAVED') }}
      </div>
      <address-form
        :address="consumerBillingAddress"
        :countries="billingCountries"
        :labels="labels"
        name="billingAddress"
        @billing-address-save="onBillingAddressSave"
      />
    </div>
  </div>
</template>
